// removed by extract-text-webpack-plugin
module.exports = {"modalBody":"AutoModal__modalBody__ba3e073e","infoContainer":"AutoModal__infoContainer__ba3e073e","image":"AutoModal__image__ba3e073e","button":"AutoModal__button__ba3e073e","link":"AutoModal__link__ba3e073e"};


//////////////////
// WEBPACK FOOTER
// ./src/abandonedCheckout/components/AutoModal.scss
// module id = ./src/abandonedCheckout/components/AutoModal.scss
// module chunks = 4